import { backboneModelProperties } from "./../../decorators/backbone-properties";
import { BaseDocumentModel } from "./base-document";
import { ReportDetailModel } from "../../desktop/models/report-detail";
import {prop} from "../../decorators/property";
import defaults from "./document-defaults";

@backboneModelProperties(defaults)
export class EUDocumentModel extends BaseDocumentModel {

    @prop() public IsLatestJudgment: boolean;
    @prop() public UniqueReportList: ReportDetailModel[];
    @prop() public CelexNumber: string;

    public public; constructor(options?: any) {
        super(options);
    }

    public loadFullText() {
        return new Promise((resolve, reject) => {
            if (this.FullTextLoaded) {
                resolve();
           } else {
               this.getFulltextFromServer(this.get("RenderType"), this.ParentId).then((response) => {
                    this.FullText = response.Fulltext ;
                    this.PdfLinks = response.PdfDetails;
                    this.HasFullText = this.FullText && this.FullText.length > 0;
                    this.HasPdf = (response.PdfDetails !== null && response.PdfDetails.length > 0 && this.checkDocHasOkPdfLink(response.PdfDetails));
                    if (response.ReportDetails && response.ReportDetails.length) {
                        this.ReportDetails = response.ReportDetails;
                        this.HasReports = true;

                        const mappedDetails = this.ReportDetails.map((details) => {
                            return {ReportName: details.ReportName, Source: details.Source};
                        });

                        this.UniqueReportList = _.uniq(mappedDetails, false, (details) => {
                            return details.ReportName;
                        });
                    }
                    this.FullTextLoaded = true;
                    resolve();
               });
            }
        });
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/desktop/models/eu-document.ts